export default __webpack_public_path__ + "static/media/ic_map_china_hub.ee5a0573.svg";